<p>This information is shown to the user when they search and add your agent.</p>

<form [formGroup]="agentForm">
    <div class="form-wrapper input-wrapper">
        @if (slEnabled()) {
        <div class="tree-view">
            <kendo-treeview
                [nodes]="sensitivityLabelData"
            textField="name"
            idField="id"
            parentIdField="parent"
                checkBy="id"
                [filterable]="false"
                [loadOnDemand]="false"
                [checkedKeys]="checkedKeys()"
                (checkedKeysChange)="onCheckedKeysChange($event)"
                [expandedKeys]="expandedKeys"
                [hasCheckbox]="hasCheckbox"

                kendoTreeViewFlatDataBinding
                kendoTreeViewExpandable
                [kendoTreeViewDisable]="'label'"
                [kendoTreeViewCheckable]="checkableSettings"
                [isDisabled]="isSensitivityLabelDisabled"
            >
                <ng-template kendoTreeViewNodeTemplate let-dataItem>
                <div class="tree-node">
                <mat-icon
                        class="material-symbols-outlined"
                        [style.color]="dataItem.color || null"
                        [fontIcon]="dataItem.icon"/>
                    <span>{{ dataItem.name }}</span>
                </div>
            </ng-template>
            </kendo-treeview>
            @if (agentForm.get('sensitivityLabels')!.hasError('sensitivityLabelInvalid') && agentForm.get('sensitivityLabels')!.touched) {
                <mat-error class="mat-mdc-form-field-error error">At least one Sensitivity Label is required.</mat-error>
            }
        </div>
        }

        <mat-form-field class="form-field">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name">

            @if (agentForm.get('name')!.hasError('required')) {
                <mat-error>Agent name is required.</mat-error>
            }
        </mat-form-field>

        <mat-form-field class="form-field">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" cdkTextareaAutosize
            cdkAutosizeMinRows="3" ></textarea>

            @if (agentForm.get('description')!.hasError('required')) {
                <mat-error>Agent description is required.</mat-error>
            }
        </mat-form-field>

        <keywords-controller [allKeywords]="allKeywords()" [parentForm]="agentForm" (keywordsChanged)="onKeywordsChanged()"/>

        <mat-form-field class="form-field">
            <mat-label>Support URL</mat-label>
            <input matInput formControlName="supportUrl">

            @if (agentForm.get('supportUrl')!.hasError('invalidUrlOrDefault')) {
                <mat-error>
                  Please enter a valid URL or 'https://'.
                </mat-error>
            }
        </mat-form-field>
    </div>
</form>
